module.exports = __webpack_public_path__ + "static/room01-503b62c7ac8519516230a2bedc1bd4c8.jpg";